<template>
  <div class="app-layout orver-hidden-x">
    <el-row type="flex" class="flex-justify-between flex-align-center">
      <el-col :span="3">
        <strong class="font-size-24">健康数据</strong>
      </el-col>
      <el-col :span="5">
        <el-date-picker
          v-model="queryForm.analyzeTime"
          align="right"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
          @change="search"
          :clearable="false"
        ></el-date-picker>
      </el-col>
    </el-row>
    <el-row class="margin-top-15">
      <el-card class="box-card" shadow="never" v-loading="queryLoading">
        <el-row type="flex" class="flex-align-center">
          <el-col
            :span="9"
            class="progress-item"
            :class="queryFlowData.healthSourceCss"
            style="border-right: 1px solid #ebebeb"
          >
            <el-row type="flex" class="flex-justify-center">
              <el-progress
                type="circle"
                :percentage="queryFlowData.healthSorce"
                :format="
                  (percentage) => {
                    return `${percentage}`;
                  }
                "
                :width="160"
                :stroke-width="10"
                :color="queryFlowData.healthSourceColor"
              ></el-progress>
              <div
                class="progress-item-tooltip"
                :style="{ 'background-color': queryFlowData.healthSourceColor }"
              >
                {{ queryFlowData.healthSorce | setHealthDesc }}
                <el-tooltip class="item" effect="dark" placement="right">
                  <div slot="content">
                    健康分说明：每个指标为100分，单个指标的异常数（率）
                    <br />即为单个指标的扣分值，最高扣100分。如客户端错误数即
                    <br />为客户端扣分，接口异常率 * 100% 即为接口扣分。
                    <br />
                    <br />最终得分：（指标数 * 100 - 每个指标的扣分值）/ 指标数
                    <br />
                    <br />状态说明： <br />极差：0-50分 <br />较差：51-75分 <br />一般：76-85分
                    <br />好：86-98分 <br />较好：99-100分
                  </div>
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </div>
            </el-row>
          </el-col>
          <el-col :span="15">
            <el-row type="flex" class="progress-group flex-justify-center">
              <el-col :span="4">
                <el-progress
                  type="circle"
                  :percentage="100"
                  :format="
                    (percentage) => {
                      return `${queryFlowData.clientError}`;
                    }
                  "
                  :width="90"
                  color="#F56C6C"
                ></el-progress>
                <p class="margin-top-20">客户端错误数</p>
              </el-col>
              <el-col :span="4">
                <el-progress
                  type="circle"
                  class="percentage-active"
                  :percentage="queryFlowData.clientErrorScale * 100"
                  :format="
                    (percentage) => {
                      return `${percentage.toFixed(2)}`;
                    }
                  "
                  :width="90"
                  color="#F56C6C"
                ></el-progress>
                <p class="margin-top-20">客户端错误率</p>
              </el-col>
              <el-col :span="4">
                <el-progress
                  type="circle"
                  :percentage="100"
                  :format="
                    (percentage) => {
                      return `${queryFlowData.apiRequest}`;
                    }
                  "
                  :width="90"
                  color="#ff9724"
                ></el-progress>
                <p class="margin-top-20">接口请求数</p>
              </el-col>
              <el-col :span="4">
                <el-progress
                  type="circle"
                  :percentage="100"
                  :format="
                    (percentage) => {
                      return `${queryFlowData.apiError}`;
                    }
                  "
                  :width="90"
                  color="#F56C6C"
                ></el-progress>
                <p class="margin-top-20">接口错误数</p>
              </el-col>
              <el-col :span="4">
                <el-progress
                  type="circle"
                  class="percentage-active"
                  :percentage="queryFlowData.apiErrorScale * 100"
                  :format="
                    (percentage) => {
                      return `${percentage.toFixed(2)}`;
                    }
                  "
                  :width="90"
                  color="#3695ff"
                ></el-progress>
                <p class="margin-top-20">接口异常率</p>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-card>
    </el-row>
    <el-row class="margin-top-15" style="margin-right: -20px">
      <el-col :span="24" class="padding-right-20">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix" style="width: 100%">
            <el-row class="flex-align-center">
              <el-col class="font-size-14" align="left">
                <div>
                  <router-link
                    :to="{
                      name: 'ApplicationAnalysisErrorReport',
                      query: {
                        name: 'first',
                        to: queryForm.analyzeTime,
                      },
                    }"
                    style="color: #303133;"
                  >
                    客户端错误趋势
                    <i class="el-icon-arrow-right"></i>
                  </router-link>
                  <el-tooltip class="item" effect="dark" placement="right">
                    <div slot="content">程序运行时出错，使用window.onerror进行异常捕获并上报</div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <!-- <div class="color-gray font-size-12">
                  {{ queryForm.analyzeTime }}
                </div>-->
              </el-col>
            </el-row>
          </div>
          <div id="lineChart1" class="chart-box small-chart-box"></div>
        </el-card>
      </el-col>
      <el-col :span="24" class="padding-right-20 margin-top-20">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix" style="width: 100%">
            <el-row class="flex-align-center">
              <el-col class="font-size-14" align="left">
                <div>
                  <router-link
                    :to="{
                      name: 'ApplicationAnalysisErrorReport',
                      query: {
                        name: 'second',
                        to: queryForm.analyzeTime,
                      },
                    }"
                    style="color: #303133;"
                  >
                    接口错误趋势
                    <i class="el-icon-arrow-right"></i>
                  </router-link>

                  <el-tooltip class="item" effect="dark" placement="right">
                    <div slot="content">网关监听的接口错误情况</div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <!-- <div class="color-gray font-size-12">
                  {{ queryForm.analyzeTime }}
                </div>-->
              </el-col>
            </el-row>
          </div>
          <div id="lineChart2" class="chart-box small-chart-box"></div>
        </el-card>
      </el-col>
    </el-row>
    <el-row type="flex" class="margin-top-15" style="margin-right: -20px">
      <el-col :span="8" class="padding-right-20"></el-col>
      <el-col :span="8" class="padding-right-20"></el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
// eslint-disable-next-line import/no-cycle
import { queryHealthData, queryClientErrorTendency, queryApiErrorTendency } from '@/api/log/index';
import { parseTime } from '@/utils';

export default {
  name: 'LogIndex',
  data() {
    return {
      queryLoading: false,
      queryForm: {
        // analyzeTimeTo: "",
        analyzeTime: parseTime(new Date(), 'yyyy-MM-dd'),
      },
      queryFlowData: {
        clientErrorScale: 0, // 客户端错误率
        apiRequest: 0, // 接口请求数
        apiError: 0, // 接口错误数
        clientError: 0,
        apiErrorScale: 0,
        healthSorce: 0,
        healthSourceColor: '#e5e9f2',
        healthSourceCss: '',
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            },
          },
        ],
      },
      lineChart1: null,
      lineChart2: null,
    };
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  mounted() {
    this.lineChart1 = this.$echarts.init(document.getElementById('lineChart1'));
    this.lineChart2 = this.$echarts.init(document.getElementById('lineChart2'));

    // 当窗口发生变化时
    window.addEventListener('resize', this.handleResize);
  },
  filters: {
    // eslint-disable-next-line consistent-return
    setHealthDesc(val) {
      if (val <= 50) {
        return '极差';
      }
      if (val >= 51 && val <= 75) {
        return '较差';
      }
      if (val >= 76 && val <= 85) {
        return '一般';
      }
      if (val >= 86 && val <= 98) {
        return '好';
      }
      if (val >= 99) {
        return '较好';
      }
    },
  },
  computed: {
    ...mapGetters('app', ['source', 'env']),
  },
  watch: {
    source: {
      handler() {
        this.search();
      },
      immediate: true,
    },
    env: {
      handler() {
        this.search();
      },
    },
  },
  methods: {
    async search() {
      try {
        this.queryLoading = true;
        this.searchChartData();
        const {
          queryForm: { analyzeTime },
        } = this;
        const { data } = await queryHealthData({
          analyzeTime,
        });

        const {
          clientError = 0, // 客户端错误数
          clientErrorScale = 0, // 客户端错误率
          apiRequest = 0, // 接口请求数
          apiError = 0, // 接口错误数
          apiErrorScale = 0, // 接口异常率
          healthSorce = 0,
        } = data || {};

        let healthSourceColor = '';
        let healthSourceCss = '';
        if (healthSorce <= 50) {
          healthSourceColor = '#303133';
          healthSourceCss = 'bad';
        }
        if (healthSorce >= 51 && healthSorce <= 75) {
          healthSourceColor = '#ff4e5c';
          healthSourceCss = 'danger';
        }
        if (healthSorce >= 76 && healthSorce <= 85) {
          healthSourceColor = '#ff9724';
          healthSourceCss = 'warning';
        }
        if (healthSorce >= 86 && healthSorce <= 98) {
          healthSourceColor = '#13ce66';
          healthSourceCss = 'success';
        }
        if (healthSorce >= 99) {
          healthSourceColor = '#13ce66';
          healthSourceCss = 'success';
        }
        this.queryFlowData = {
          clientErrorScale, // 客户端错误率
          apiRequest, // 接口请求数
          apiError, // 接口错误数
          clientError,
          healthSorce,
          apiErrorScale,
          healthSourceCss,
          healthSourceColor,
        };
      } catch (e) {
        console.log(e);
      } finally {
        this.queryLoading = false;
      }
    },
    async searchChartData() {
      const {
        queryForm: { analyzeTime },
      } = this;
      const analyzeTimeFrom = parseTime(new Date(new Date(analyzeTime).getTime()), 'yyyy-MM-dd');
      const referAnalyzeTime = parseTime(
        new Date(new Date(analyzeTimeFrom).getTime() - 604800000),
        'yyyy-MM-dd',
      );

      // this.queryForm.analyzeTimeTo = analyzeTime;
      // 趋势
      this.renderTrendData(analyzeTime, analyzeTimeFrom, referAnalyzeTime);
    },
    async renderTrendData(analyzeTime, analyzeTimeFrom, referAnalyzeTime) {
      const params = {
        analyzeTimeFrom: `${analyzeTimeFrom} 00`,
        analyzeTimeTo: `${analyzeTime} 23`,
        referAnalyzeTime,
      };
      Promise.all([
        await this.renderPromiseMethods(queryClientErrorTendency, params),
        await this.renderPromiseMethods(queryApiErrorTendency, params),
      ]).then((res) => {
        res.forEach((item, index) => {
          if (item) {
            const {
              data: { clientErrors, apiErrors },
            } = item;
            let array = [];
            let chartType = '';
            // eslint-disable-next-line default-case
            switch (index) {
              case 0:
                array = clientErrors;
                chartType = 'lineChart1';
                break;
              case 1:
                array = apiErrors;
                chartType = 'lineChart2';
                break;
            }

            const yArray = [];
            const xArray = [];
            // const xReferArray = [];
            const yReferArray = [];
            const curHours = new Date().getHours();
            // eslint-disable-next-line operator-linebreak
            const isSameDate =
              // eslint-disable-next-line operator-linebreak
              parseTime(new Date(`${params.analyzeTimeFrom}:00:00`), 'yyyy-MM-dd') ===
              parseTime(new Date(new Date().getTime()), 'yyyy-MM-dd');

            array.forEach(
              // eslint-disable-next-line no-shadow
              ({ currentAnalyzeTime, current, refer }, index) => {
                xArray.push(currentAnalyzeTime.replace(/:00:00/g, ''));
                // xReferArray.push(referAnalyzeTime);
                if (curHours >= index || !isSameDate) {
                  yArray.push(current ?? 0);
                  yReferArray.push(refer ?? 0);
                }
              },
            );

            // eslint-disable-next-line no-unused-expressions
            this[chartType] && this[chartType].clear(); // 消除当前实例
            const option = this.renderTrendChart(xArray, yArray, yReferArray);
            this[chartType].setOption(option);
          }
        });
      });
    },
    async renderPromiseMethods(method, params) {
      try {
        const res = await method(params);
        return res;
      } catch (e) {
        return null;
      }
    },
    renderTrendChart(xArray, yArray, yReferArray) {
      return {
        // 平滑
        smooth: true,
        tooltip: {
          trigger: 'axis',
          backgroundColor: null,
          borderWidth: 0,
          borderRadius: 0,
          axisPointer: {
            type: 'line',
            axis: 'x',
            label: {
              show: true,
              color: 'rgb(255, 151, 36)',
              backgroundColor: 'rgba(255, 255, 255, .8)',
              shadowBlur: 0,
              margin: 0,
            },
            lineStyle: {
              type: 'dashed',
              color: '#b6b5b7',
            },
          },
          textStyle: {
            color: '#333',
            align: 'left',
            fontSize: 14,
          },
          formatter(params) {
            const res = `
              <div style="
                padding: 10px;
                box-shadow: 0 0 3px 3px rgba(0,0,0, .09);
                background: #fff;
                border-radius: 5px;"
              >
                <div>${params[0].axisValueLabel}</div>
                <div style="display: flex;min-width: 120px;justify-content: space-between">
                  <div>
                    <p
                      style="
                      display: inline-block;
                      border-radius: 10px;
                      height: 10px;
                      width: 10px;
                      background-color: ${params[0].color};"
                    ></p>
                    ${params[0].seriesName}
                  </div>
                  <p><strong>${params[0].value}</strong></p>
                </div>
                <div style="display: flex;min-width: 120px;justify-content: space-between">
                  <div>
                    <p
                      style="
                      display: inline-block;
                      border-radius: 10px;
                      height: 10px;
                      width: 10px;
                      background-color: ${params[1].color};"
                    ></p>
                    ${params[1].seriesName}
                  </div>
                  <p><strong>${params[1].value}</strong></p>
                </div>
              </div>`;
            return res;
          },
          position(point, params, dom, rect, size) {
            // 其中point为当前鼠标的位置，size中有两个属性：viewSize和contentSize，分别为外层div和tooltip提示框的大小
            const x = point[0]; //
            const y = point[1];
            const boxWidth = size.contentSize[0];
            const boxHeight = size.contentSize[1];
            let posX = 0; // x坐标位置
            let posY = 0; // y坐标位置

            if (x < boxWidth) {
              // 左边放不开
              posX = 5;
            } else {
              // 左边放的下
              posX = x - boxWidth;
            }

            if (y < boxHeight) {
              // 上边放不开
              posY = 5;
            } else {
              // 上边放得下
              posY = y - boxHeight;
            }

            return [posX, posY];
          },
        },
        // toolbox: {
        //   feature: {
        //     dataZoom: {
        //       yAxisIndex: 'none',
        //     },
        //     restore: {},
        //     saveAsImage: {},
        //   },
        // },
        grid: {
          height: '200',
          left: '0%',
          right: '2%',
          bottom: '4%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xArray,
          // 设置轴线的属性
          axisLine: {
            lineStyle: {
              color: '#f2f2f2',
              // width: 8
            },
          },
          // 网格
          splitLine: {
            show: false,
          },
          axisLabel: {
            // textStyle: {
            color: '#b6b5b7', // 坐标值得具体的颜色
            // },
          },
        },
        yAxis: {
          type: 'value',
          boundaryGap: false,
          // 设置轴线的属性
          axisLine: {
            show: true,
            lineStyle: {
              color: '#f2f2f2',
              // width: 8
            },
          },
          // 网格
          splitLine: {
            show: false,
          },
          axisLabel: {
            // textStyle: {
            color: '#b6b5b7', // 坐标值得具体的颜色
            // },
          },
        },
        // dataZoom: [
        //   {
        //     type: 'inside',
        //     start: 0,
        //     end: 10,
        //   },
        //   {
        //     start: 0,
        //     end: 10,
        //   },
        // ],
        series: [
          {
            name: '一周前',
            type: 'line',
            smooth: true, // 设置折线图平滑
            lineStyle: {
              width: 4,
              type: 'solid', // 'dotted'虚线 'solid'实线
            },
            itemStyle: {
              color: 'rgb(174, 189, 238)',
            },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgb(171, 185, 249)',
                },
                {
                  offset: 1,
                  color: 'rgb(251, 252, 255)',
                },
              ]),
            },
            data: yReferArray,
          },
          {
            name: '当前',
            type: 'line',
            smooth: true, // 设置折线图平滑
            lineStyle: {
              width: 4,
              type: 'solid', // 'dotted'虚线 'solid'实线
            },
            itemStyle: {
              color: 'rgb(255, 151, 36)',
            },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgb(255, 186, 110)',
                },
                {
                  offset: 1,
                  color: 'rgb(255, 253, 252)',
                },
              ]),
            },
            data: yArray,
          },
        ],
      };
    },
    handleResize() {
      // const barChart = document.getElementById('barChart');
      // this.resizeDom(); //重置div宽高度
      this.lineChart1.resize(); // 重绘echart图表
      this.lineChart2.resize(); // 重绘echart图表
    },
    // resizeDom(dom) {//通过窗体高宽计算容器高宽，渲染echart图表的div的宽高度已达到自适应目的
    //   // dom.style.width = (window.innerWidth-15)+'px';
    //   // dom.style.height = (window.innerHeight-35)+'px';
    //   //
    //   console.log(document.getElementById('barChart').clientWidth);
    // }
  },
};
</script>
<style lang="scss" scoped>
.color-green {
  color: #00af56;
}
.color-red {
  color: #f85149;
}
.color-gray {
  color: #a3a5b0;
}
.user-chart-box {
  height: 200px;
}
.small-chart-box {
  height: 220px;
}
.app-layout {
  min-width: 800px;
  margin: 15px 15px 0;
}
.progress-item-tooltip {
  min-width: 50px;
  padding: 0 10px;
  height: 32px;
  border-radius: 19px 19px 19px 0;
  color: #fff;
  text-align: center;
  line-height: 32px;
}
.progress-item {
  position: relative;
  &::v-deep {
    .el-progress__text {
      font-size: 50px !important;
      font-weight: bold;
      &:after {
        display: block;
        content: '健康状态';
        font-size: 12px;
        margin-top: 15px;
        color: #303133;
      }
    }
  }
}
.progress-item.bad {
  &::v-deep {
    .el-progress__text {
      color: #303133;
    }
  }
}
.progress-item.danger {
  &::v-deep {
    .el-progress__text {
      color: #ff4e5c;
    }
  }
}
.progress-item.warning {
  &::v-deep {
    .el-progress__text {
      color: #ff9724;
    }
  }
}
.progress-item.success {
  &::v-deep {
    .el-progress__text {
      color: #13ce66;
    }
  }
}
.progress-group {
  &::v-deep {
    .el-progress__text {
      font-size: 23px !important;
      font-weight: bold;
    }
  }
}
.percentage-active {
  &::v-deep {
    .el-progress__text {
      &:after {
        content: '%';
        font-size: 12px;
        margin-left: 1px;
      }
    }
  }
}
</style>
